import React from "react";
import { SignInButton } from "@clerk/clerk-react";
import SignInHelper from "./SignInHelper";
import UserDashboard from "../UserDashboard";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../../store/slices/authentication";

function App() {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <div className="w-[100vw] app-full-height">
      {!isAuthenticated ? (
        // Scrolls rather than centring with justify-center: with the helper
        // open the card can be taller than a phone screen, and a centred
        // column that overflows cuts off its top where nobody can scroll to it.
        // my-auto still centres the card whenever it fits.
        <div className="flex flex-col w-full h-full items-center overflow-y-auto bg-dupontCream dark:bg-darkPrimary px-6 py-6">
          <div className="my-auto w-full max-w-[440px] text-center bg-white dark:bg-darkCard border border-dupontCreamDk/60 dark:border-darkGold/10 rounded-2xl shadow-lg px-5 sm:px-8 py-10">
            <img
              src={`${process.env.PUBLIC_URL}/DuPontCrestIcon.png`}
              alt="du Pont family crest"
              className="w-[84px] h-[84px] object-contain mx-auto mb-4"
            />
            <h1 className="font-display text-[30px] font-bold text-dupontBlue dark:text-darkText mb-2">
              Welcome to du&nbsp;Pont Circle
            </h1>
            <p className="font-body text-[16px] text-dupontGray dark:text-darkTextSecondary leading-relaxed mb-7">
              Our family's private home online — the family tree, a member
              directory, the bulletin board, and more. Sign in with the email
              address your invitation was sent to.
            </p>
            <SignInButton>
              <button className="px-8 py-3 bg-dupontBlue text-white rounded-full text-[17px] font-semibold hover:bg-dupontBlue/90 transition-colors shadow-sm cursor-pointer">
                Sign in
              </button>
            </SignInButton>
            <SignInHelper />
          </div>
        </div>
      ) : (
        <div className="flex flex-col w-full h-full">
          <UserDashboard />
        </div>
      )}
    </div>
  );
}

export default App;
